/* ==========================================================
   כפתור "הוסף לעגלה" הצף במובייל – מוסיף מימין את התמונה והשם
   של המארז שנבחר (כרטיס quantity_bundle עם ה-radio המסומן) ואת תג המתנה שלו,
   ומעדכן אותם בכל פעם שבוחרים מארז אחר. כשמסמנים את האפסל (מארז ה-VIP), מופיעה
   מתחת לשם שורה קטנה "+ מארז VIP · 49₪".
   משלים את assets/claude-sticky-atc.css.
   ========================================================== */
(function () {
  'use strict';

  function imageSrc(img) {
    if (!img) return '';
    var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
    if (!src) {
      var set = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      src = set.split(',')[0].trim().split(' ')[0];
    }
    return src;
  }

  function selectedBundle() {
    var cards = document.querySelectorAll('.quantity-bundle-card');
    for (var i = 0; i < cards.length; i++) {
      var input = cards[i].querySelector('input[type="radio"]');
      if (input && input.checked) return cards[i];
    }
    return cards[0] || null;
  }

  function bundleName(card) {
    var title = card && card.querySelector('.quantity-bundle-title');
    if (!title) return '';
    // בלי התג "+1 במתנה" שבתוך הכותרת
    var text = '';
    title.childNodes.forEach(function (n) {
      if (n.nodeType === 3) text += n.textContent;
    });
    return text.trim() || title.textContent.trim();
  }

  // שם ארוך מדי (למשל "מארז שלישיה" ליד תג המתנה) – מקטינים את הגופן עד
  // שהשם כולו נכנס, לכל היותר עד 11px; רק אם עדיין לא נכנס מופיעות "..."
  var NAME_MAX = 15;
  var NAME_MIN = 11;

  function fitName(el) {
    if (!el || !el.offsetParent) return;
    var size = NAME_MAX;
    el.style.fontSize = size + 'px';
    while (size > NAME_MIN && el.scrollWidth > el.clientWidth + 1) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
  }

  function update() {
    var wrapper = document.querySelector('.sticky-add-to-cart .mobile-button-wrapper');
    if (!wrapper) return;

    var box = wrapper.querySelector('.csa-product');
    if (!box) {
      box = document.createElement('div');
      box.className = 'csa-product';
      box.innerHTML = '<span class="csa-thumb"><img alt="" loading="eager"></span>' +
        '<span class="csa-info"><span class="csa-line"><span class="csa-name"></span><span class="csa-gift"></span></span>' +
        '<span class="csa-extra"></span></span>';
      wrapper.insertBefore(box, wrapper.firstChild);

      // מתאימים את גודל השם בכל פעם שהפס מופיע או משנה רוחב
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          fitName(box.querySelector('.csa-name'));
        }).observe(wrapper);
      }
    }

    var card = selectedBundle();
    var img = box.querySelector('img');
    var src = card ? imageSrc(card.querySelector('img')) : '';
    if (!src) {
      var fallback = document.querySelector('.sticky-add-to-cart__image img');
      src = imageSrc(fallback);
    }
    if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
    box.querySelector('.csa-thumb').style.display = src ? '' : 'none';

    var name = bundleName(card);
    if (!name) {
      var title = document.querySelector('.sticky-add-to-cart__title');
      name = title ? title.textContent.trim() : '';
    }
    box.querySelector('.csa-name').textContent = name;
    img.alt = name;

    // התג "+1 במתנה" / "+2 במתנה" של המארז (כמו בכרטיס), אם יש
    var giftEl = card && card.querySelector('.cb-gift');
    var gift = box.querySelector('.csa-gift');
    gift.textContent = giftEl ? giftEl.textContent.trim() : '';
    gift.style.display = gift.textContent ? '' : 'none';

    // שורה שנייה: האפסל המסומן (מארז VIP), עם המחיר מהגדרות הבלוק
    var extras = [];
    document.querySelectorAll('.claude-upsell-checkbox').forEach(function (up) {
      var input = up.querySelector('.upsell-toggle-input');
      if (!input || !input.checked) return;
      var label = 'מארז VIP';
      var price = Number(up.dataset.cartPrice) || 0;
      // סימני כיוון (\u200F) – כדי שה"+" וה-₪ יעמדו נכון ליד "VIP" והמספר
      extras.push('\u200F+ ' + label + '\u200F' + (price ? ' · ' + price + '\u200F₪' : ''));
    });
    var extra = box.querySelector('.csa-extra');
    var extraText = extras.join(' ');
    if (extra.textContent !== extraText) extra.textContent = extraText;
    box.classList.toggle('csa-has-extra', !!extraText);

    fitName(box.querySelector('.csa-name'));
  }

  function init() {
    update();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.quantity-bundle-card, .claude-upsell-checkbox')) update();
    });
    // הסנכרון מול העגלה מסמן/מבטל את האפסל בלי אירוע – בודקים מדי פעם
    setInterval(update, 800);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.quantity-bundle-card')) setTimeout(update, 0);
    });
    window.addEventListener('load', update);
    window.addEventListener('resize', function () {
      fitName(document.querySelector('.sticky-add-to-cart .csa-name'));
    });
    // הפס מוסתר עד שגוללים – מתאימים את השם כשהוא מופיע
    window.addEventListener('scroll', function () {
      var el = document.querySelector('.sticky-add-to-cart .csa-name');
      if (el && el.dataset.fitted !== el.textContent && el.offsetParent && el.clientWidth) {
        fitName(el);
        el.dataset.fitted = el.textContent;
      }
    }, { passive: true });
    document.addEventListener('shopify:section:load', function () { setTimeout(update, 50); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
